/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { GetMediaExportJobsByIdQueryResponse, GetMediaExportJobsByIdPathParams, GetMediaExportJobsById404 } from "../models/GetMediaExportJobsById";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getMediaExportJobsById } from "../axios/getMediaExportJobsById";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getMediaExportJobsByIdQueryKey = (id: GetMediaExportJobsByIdPathParams["id"]) => ["web-app-bff-api", { url: '/export-jobs/:id', params: {id:id} }] as const

export type GetMediaExportJobsByIdQueryKey = ReturnType<typeof getMediaExportJobsByIdQueryKey>

export function getMediaExportJobsByIdQueryOptions(id: GetMediaExportJobsByIdPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getMediaExportJobsByIdQueryKey(id)
        return queryOptions<GetMediaExportJobsByIdQueryResponse, ResponseErrorConfig<GetMediaExportJobsById404>, GetMediaExportJobsByIdQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return getMediaExportJobsById(id, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns a single export job for the current user. Result includes fileSize only when completed (no storage URL).
 * @summary Get export job by id
 * {@link /export-jobs/:id}
 */
export function useGetMediaExportJobsById<TData = GetMediaExportJobsByIdQueryResponse, TQueryData = GetMediaExportJobsByIdQueryResponse, TQueryKey extends QueryKey = GetMediaExportJobsByIdQueryKey>(id: GetMediaExportJobsByIdPathParams["id"], options: 
{
  query?: Partial<QueryObserverOptions<GetMediaExportJobsByIdQueryResponse, ResponseErrorConfig<GetMediaExportJobsById404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? getMediaExportJobsByIdQueryKey(id)
         

         const query = useQuery({
          ...getMediaExportJobsByIdQueryOptions(id, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetMediaExportJobsById404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}